import { Component } from '@angular/core';
import { MdDialog } from '@angular/material';

import { Habito } from '../../../../models';
import { TdDialogService } from '@covalent/core';

@Component({
  selector: 'qs-detallehabitos',
  templateUrl: './detallehabitos.component.html',
})

export class HabitosDetalleComponent {

  public habito: Habito;

  constructor(private _dialogService: TdDialogService) { }

  close(): void {
    this._dialogService.closeAll();
  }
}



// WEBPACK FOOTER //
// ./src/app/consulta/habitos/detallehabitos/detallehabitos.component.ts